import {combineReducers} from 'redux';
import authSlice from './auth/auth-slice';
import dataGridSlice from './data-grid/data-grid-slice';
import companiesSlice from './companies/companies-slice';
import rolesManagementSlice from './roles-management/roles-management-slice';
import usersManagementSlice from './users-management/users-management-slice';
import questionsManagementSlice from './questions-management/questions-management-slice';
import notificationsSlice from './notifications/notification-slice';
import treatmentsSlice from './treatments/treatments-slice';
import packagesSlice from './packages/packages-slice';
import casePricingSlice from './case-pricing/case-pricing-slice';
import casesSlice from './cases/cases-slice';
import caseTreatmentMaterialSlice from './case-material/case-material-slice';
import treatmentColorsSlice from './treatment-color/treatment-color-slice';
import chatSlice from './chat/chat-slice';

export let reducer = combineReducers({
  auth: authSlice,
  dataGrid: dataGridSlice,
  companies: companiesSlice,
  rolesManagement: rolesManagementSlice,
  usersManagement: usersManagementSlice,
  questionsManagement: questionsManagementSlice,
  notifications: notificationsSlice,
  treatments: treatmentsSlice,
  packages: packagesSlice,
  casePricing: casePricingSlice,
  cases: casesSlice,
  caseTreatmentMaterial: caseTreatmentMaterialSlice,
  treatmentColors: treatmentColorsSlice,
  chat: chatSlice,
});
